// extracted by mini-css-extract-plugin
export default {"buttonMain":"SurveysPageMenuItem_buttonMain__9Mlta","buttonSelected":"SurveysPageMenuItem_buttonSelected__J4ZGq","title":"SurveysPageMenuItem_title__PC0rD"};